module.exports = __webpack_public_path__ + "img/wuman.bcd00526.png";